import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { PeopleEquipmentsTable } from './-components/EquipmentList';
import { EquipmentSearchSchema } from './-zod-schema';

const from = '/_staff/person/$id/_profile/equipment/';

export const Route = createFileRoute('/_staff/person/$id/_profile/equipment/')({
  component: RouteComponent,
  validateSearch: zodValidator(EquipmentSearchSchema),
});

function RouteComponent() {
  return <PeopleEquipmentsTable from={from} />;
}
